import React from 'react';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';

import { FormikRadio } from './FieldTypes';
import Asterisk from '@atoms/Asterisk';
import { ErrorText, ResponsiveBlock } from '@styled';

const FundAmount = ({ amount, onAmountChange }) => (
    <fieldset>
        <legend>
            <ResponsiveBlock>
                Select an Amount
                <Asterisk />
            </ResponsiveBlock>

            <ResponsiveBlock>
                <ErrorText className="legend-error">
                    <ErrorMessage name="amount" />
                </ErrorText>
            </ResponsiveBlock>
        </legend>

        <FormikRadio
            name="amount"
            type="radio"
            id="Fund25"
            value="25"
            label="$25.00"
            checked={amount === '25'}
            onChange={event => onAmountChange(event)}
        />

        <FormikRadio
            name="amount"
            type="radio"
            id="Fund50"
            value="50"
            label="$50.00"
            checked={amount === '50'}
            onChange={event => onAmountChange(event)}
        />

        <FormikRadio
            name="amount"
            type="radio"
            id="Fund100"
            value="100"
            label="$100.00"
            checked={amount === '100'}
            onChange={event => onAmountChange(event)}
        />

        <FormikRadio
            name="amount"
            type="radio"
            id="Fund250"
            value="250"
            label="$250.00"
            checked={amount === '250'}
            onChange={event => onAmountChange(event)}
        />

        <FormikRadio
            name="amount"
            type="radio"
            id="Fund500"
            value="500"
            label="$500.00"
            checked={amount === '500'}
            onChange={event => onAmountChange(event)}
        />

        <FormikRadio
            name="amount"
            type="radio"
            id="Fund1k"
            value="1000"
            label="$1,000.00"
            checked={amount === '1000'}
            onChange={event => onAmountChange(event)}
        />

        <FormikRadio
            name="amount"
            type="radio"
            id="FundOther"
            value="other"
            label="Other"
            checked={amount === 'other'}
            onChange={event => onAmountChange(event)}
        />
    </fieldset>
);

FundAmount.propTypes = {
    amount: PropTypes.any.isRequired,
    onAmountChange: PropTypes.func.isRequired,
};

export default FundAmount;
